import { useState } from 'react';
import { Link } from 'react-router-dom';

// ---------------------------------------------------------------------------
// SVG Illustrations
// ---------------------------------------------------------------------------

function HeroIllustration() {
  return (
    <svg viewBox="0 0 400 400" fill="none" className="w-full max-w-md mx-auto" aria-hidden="true">
      {/* Background circle */}
      <circle cx="200" cy="200" r="180" fill="#f5efe5" />

      {/* Connecting lines (dashed curves) */}
      <path d="M200 150 Q160 100 200 80" stroke="#a8c3aa" strokeWidth="1.5" strokeDasharray="6 4" strokeLinecap="round" />
      <path d="M250 200 Q290 180 320 200" stroke="#a8c3aa" strokeWidth="1.5" strokeDasharray="6 4" strokeLinecap="round" />
      <path d="M200 250 Q160 300 200 320" stroke="#a8c3aa" strokeWidth="1.5" strokeDasharray="6 4" strokeLinecap="round" />
      <path d="M150 200 Q110 180 80 200" stroke="#a8c3aa" strokeWidth="1.5" strokeDasharray="6 4" strokeLinecap="round" />

      {/* Central home circle */}
      <circle cx="200" cy="200" r="52" fill="#e6ede6" stroke="#6b8f71" strokeWidth="2" />
      {/* House icon */}
      <path d="M185 210v-8a2 2 0 012-2h6v10M200 188l-16 12h32l-16-12z" stroke="#435b45" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M213 210v-8a2 2 0 00-2-2h-6" stroke="#435b45" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="186" y1="210" x2="214" y2="210" stroke="#435b45" strokeWidth="2" strokeLinecap="round" />

      {/* Top - Person circle */}
      <circle cx="200" cy="75" r="28" fill="#fbe9e1" stroke="#c4755b" strokeWidth="1.5" />
      <circle cx="200" cy="68" r="6" stroke="#c4755b" strokeWidth="1.5" />
      <path d="M190 82a10 10 0 0120 0" stroke="#c4755b" strokeWidth="1.5" strokeLinecap="round" />

      {/* Right - Heart circle */}
      <circle cx="325" cy="200" r="28" fill="#e6ede6" stroke="#6b8f71" strokeWidth="1.5" />
      <path d="M325 210c-8-6-14-10-14-15a6 6 0 0112-2 2 2 0 012 2 6 6 0 0112 2c0 5-6 9-14 15z" fill="#6b8f71" opacity="0.6" />

      {/* Bottom - Clipboard circle */}
      <circle cx="200" cy="325" r="28" fill="#fbe9e1" stroke="#c4755b" strokeWidth="1.5" />
      <rect x="191" y="312" width="18" height="22" rx="2" stroke="#c4755b" strokeWidth="1.5" fill="none" />
      <rect x="196" y="309" width="8" height="4" rx="1" stroke="#c4755b" strokeWidth="1.5" fill="#fbe9e1" />
      <line x1="196" y1="321" x2="207" y2="321" stroke="#c4755b" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="196" y1="326" x2="204" y2="326" stroke="#c4755b" strokeWidth="1.5" strokeLinecap="round" />

      {/* Left - Calendar circle */}
      <circle cx="75" cy="200" r="28" fill="#e6ede6" stroke="#6b8f71" strokeWidth="1.5" />
      <rect x="62" y="191" width="26" height="22" rx="2" stroke="#6b8f71" strokeWidth="1.5" fill="none" />
      <line x1="62" y1="198" x2="88" y2="198" stroke="#6b8f71" strokeWidth="1.5" />
      <line x1="70" y1="188" x2="70" y2="194" stroke="#6b8f71" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="80" y1="188" x2="80" y2="194" stroke="#6b8f71" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="70" cy="204" r="1.5" fill="#6b8f71" />
      <circle cx="80" cy="204" r="1.5" fill="#6b8f71" />
      <circle cx="70" cy="209" r="1.5" fill="#6b8f71" />

      {/* Decorative dots */}
      <circle cx="140" cy="110" r="3" fill="#cddcce" />
      <circle cx="280" cy="130" r="4" fill="#f7d2c3" />
      <circle cx="300" cy="290" r="3" fill="#cddcce" />
      <circle cx="100" cy="300" r="4" fill="#f7d2c3" />
      <circle cx="260" cy="100" r="2.5" fill="#cddcce" />
      <circle cx="120" cy="280" r="2.5" fill="#f7d2c3" />
    </svg>
  );
}

function ClipboardIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
      <rect x="9" y="3" width="6" height="4" rx="1" />
      <path d="M9 14l2 2 4-4" />
    </svg>
  );
}

function PillIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M8.5 2h7a2 2 0 012 2v16a2 2 0 01-2 2h-7a2 2 0 01-2-2V4a2 2 0 012-2z" />
      <line x1="6.5" y1="12" x2="17.5" y2="12" />
      <circle cx="10" cy="7.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="14" cy="7.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
      <circle cx="8" cy="15" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="15" r="1" fill="currentColor" stroke="none" />
      <circle cx="16" cy="15" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M12 15c-2-1.5-3.5-3-3.5-4.5a3.5 3.5 0 017 0c0 1.5-1.5 3-3.5 4.5z" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  );
}

function HeartIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
    </svg>
  );
}

function MenuIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

// ---------------------------------------------------------------------------
// Data
// ---------------------------------------------------------------------------

const features = [
  {
    icon: ClipboardIcon,
    title: 'Task Coordination',
    description: 'Assign tasks, set due dates, and track completion. Everyone knows who is doing what.',
  },
  {
    icon: PillIcon,
    title: 'Medication Tracking',
    description: 'Schedule medications, log doses, and never miss a treatment. Track across the whole family.',
  },
  {
    icon: CalendarIcon,
    title: 'Appointment Scheduling',
    description: 'Keep every GP visit, specialist appointment, and check-up visible to the whole care team.',
  },
  {
    icon: ShieldIcon,
    title: 'Emergency Profiles',
    description: 'Critical information — conditions, allergies, GP contacts — always accessible when it matters most.',
  },
];

const steps = [
  {
    number: '1',
    title: 'Create your family',
    description: 'Sign up and name your care group in under a minute.',
  },
  {
    number: '2',
    title: 'Add who you care for',
    description: "Add your loved one's profile, medications, and key details.",
  },
  {
    number: '3',
    title: 'Invite your family',
    description: 'Bring in siblings, partners, or carers. Everyone sees the same dashboard.',
  },
];

const trustPillars = [
  {
    icon: ShieldIcon,
    title: 'Privacy-first',
    description: 'Your data is never sold. No ads, ever.',
  },
  {
    icon: LockIcon,
    title: 'Secure by design',
    description: 'Encrypted data and GDPR compliant from day one.',
  },
  {
    icon: HeartIcon,
    title: 'Built with care',
    description: 'Designed by caregivers, for caregivers.',
  },
];

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function LandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'annual'>('annual');

  return (
    <div className="min-h-screen bg-cream-50">
      {/* Skip to content */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[60] focus:bg-white focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:text-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        Skip to content
      </a>

      {/* ----------------------------------------------------------------- */}
      {/* Header                                                            */}
      {/* ----------------------------------------------------------------- */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-cream-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <span className="font-fraunces text-2xl font-light tracking-tight text-navy-mid">
                <em className="font-medium text-primary-500" style={{ fontStyle: 'italic' }}>Kin</em>Care
              </span>
              <span className="hidden sm:inline text-sm text-gray-500">Care together.</span>
            </Link>

            {/* Desktop nav */}
            <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation">
              <a href="#features" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                Features
              </a>
              <a href="#how-it-works" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                How It Works
              </a>
              <a href="#pricing" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                Pricing
              </a>
              <Link to="/roadmap" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                Roadmap
              </Link>
            </nav>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center gap-3">
              <Link to="/login" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                Sign In
              </Link>
              <Link to="/signup" className="btn btn-accent text-sm">
                Get Started
              </Link>
            </div>

            {/* Mobile menu toggle */}
            <button
              className="md:hidden p-2 text-gray-600 hover:text-gray-900"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-expanded={mobileMenuOpen}
              aria-controls="mobile-menu"
              aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div id="mobile-menu" className="md:hidden bg-white border-t border-cream-200">
            <div className="px-4 py-4 space-y-3">
              <a
                href="#features"
                className="block text-sm text-gray-600 hover:text-gray-900 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Features
              </a>
              <a
                href="#how-it-works"
                className="block text-sm text-gray-600 hover:text-gray-900 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                How It Works
              </a>
              <a
                href="#pricing"
                className="block text-sm text-gray-600 hover:text-gray-900 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </a>
              <hr className="border-cream-200" />
              <Link to="/login" className="block text-sm text-gray-600 hover:text-gray-900 py-2">
                Sign In
              </Link>
              <Link to="/signup" className="block btn btn-accent text-sm text-center">
                Get Started
              </Link>
            </div>
          </div>
        )}
      </header>

      <main id="main-content">
        {/* --------------------------------------------------------------- */}
        {/* Hero                                                            */}
        {/* --------------------------------------------------------------- */}
        <section className="py-16 sm:py-20 lg:py-28">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center">
              {/* Text */}
              <div>
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                  Care for your family,{' '}
                  <span className="text-primary-600">together.</span>
                </h1>
                <p className="text-lg sm:text-xl text-gray-600 mt-6 max-w-xl">
                  Coordinate medications, appointments, and daily care across your whole family.
                  Finally, everyone stays in the loop.
                </p>
                <div className="mt-8 flex flex-col sm:flex-row items-start gap-4">
                  <Link
                    to="/signup"
                    className="btn btn-accent text-lg px-8 py-3"
                  >
                    Get Started — It's Free
                  </Link>
                </div>
                <p className="text-sm text-gray-500 mt-3">
                  No credit card required
                </p>
              </div>

              {/* Illustration */}
              <div className="mt-12 lg:mt-0">
                <HeroIllustration />
              </div>
            </div>
          </div>
        </section>

        {/* --------------------------------------------------------------- */}
        {/* Features                                                        */}
        {/* --------------------------------------------------------------- */}
        <section id="features" className="py-16 sm:py-20 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
                Everything your family needs
              </h2>
              <p className="mt-4 text-lg text-gray-600">
                Simple tools that help your family coordinate care without the chaos.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature) => (
                <div key={feature.title} className="text-center sm:text-left">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary-100 text-primary-700 mb-4">
                    <feature.icon />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* --------------------------------------------------------------- */}
        {/* How It Works                                                    */}
        {/* --------------------------------------------------------------- */}
        <section id="how-it-works" className="py-16 sm:py-20 lg:py-24 bg-cream-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
                Up and running in minutes
              </h2>
              <p className="mt-4 text-lg text-gray-600">
                Get your family coordinated in three simple steps.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
              {steps.map((step, index) => (
                <div key={step.number} className="relative text-center">
                  {/* Connector line (desktop only, between steps) */}
                  {index < steps.length - 1 && (
                    <div className="hidden md:block absolute top-8 left-[60%] w-[80%] border-t-2 border-dashed border-accent-300" aria-hidden="true" />
                  )}
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent-100 text-accent-700 text-2xl font-bold mb-4 relative z-10">
                    {step.number}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-600 max-w-xs mx-auto">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* --------------------------------------------------------------- */}
        {/* Trust                                                           */}
        {/* --------------------------------------------------------------- */}
        <section className="py-16 sm:py-20 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
                Built for families who take care seriously
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-12">
              {trustPillars.map((pillar) => (
                <div key={pillar.title} className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-cream-200 text-primary-700 mb-4">
                    <pillar.icon />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {pillar.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {pillar.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* --------------------------------------------------------------- */}
        {/* Pricing                                                         */}
        {/* --------------------------------------------------------------- */}
        <section id="pricing" className="py-16 sm:py-20 lg:py-24 bg-cream-100">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-2xl mx-auto mb-10">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
                Pricing that grows with your family
              </h2>
              <p className="mt-4 text-lg text-gray-600">
                Start free. Upgrade when your family needs more.
              </p>
            </div>

            {/* Billing toggle */}
            <div className="flex justify-center mb-10">
              <div className="inline-flex items-center gap-1 bg-white rounded-lg p-1 shadow-sm" role="group" aria-label="Billing cycle">
                <button
                  type="button"
                  onClick={() => setBillingCycle('monthly')}
                  className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                    billingCycle === 'monthly'
                      ? 'bg-cream-100 text-gray-900 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Monthly
                </button>
                <button
                  type="button"
                  onClick={() => setBillingCycle('annual')}
                  className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                    billingCycle === 'annual'
                      ? 'bg-cream-100 text-gray-900 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Annual
                  <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-2 py-0.5 rounded-full">
                    Save 33%
                  </span>
                </button>
              </div>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 items-start">
              {/* Free card */}
              <div className="bg-white border border-gray-200 rounded-2xl p-8">
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-gray-900">Free</h3>
                  <p className="text-sm text-gray-500 mt-1">For families getting started</p>
                  <div className="mt-4 flex items-baseline gap-1">
                    <span className="text-4xl font-bold text-gray-900">£0</span>
                    <span className="text-gray-500 text-sm">/ forever</span>
                  </div>
                </div>
                <Link to="/signup" className="block w-full btn btn-primary text-center mb-8">
                  Get started free
                </Link>
                <ul className="space-y-3">
                  {[
                    '1 person in your care',
                    'Up to 3 family members',
                    'Tasks, medications & appointments',
                    'Emergency profiles',
                    '30 days of activity history',
                  ].map((feature) => (
                    <li key={feature} className="flex items-start gap-3">
                      <svg className="h-5 w-5 flex-shrink-0 text-gray-400 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" strokeWidth={1.5} />
                        <path d="M8 12l3 3 5-5" />
                      </svg>
                      <span className="text-sm text-gray-600">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* KinCare Family card */}
              <div className="bg-primary-600 rounded-2xl p-8 shadow-xl relative">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="inline-block bg-accent-300 text-accent-700 text-xs font-semibold px-4 py-1 rounded-full shadow-sm">
                    Most popular
                  </span>
                </div>
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-white">KinCare Family</h3>
                  <p className="text-sm text-primary-100 mt-1">For families with bigger needs</p>
                  <div className="mt-4 flex items-baseline gap-1">
                    {billingCycle === 'monthly' ? (
                      <>
                        <span className="text-4xl font-bold text-white">£5.99</span>
                        <span className="text-primary-100 text-sm">/ month</span>
                      </>
                    ) : (
                      <>
                        <span className="text-4xl font-bold text-white">£4.00</span>
                        <span className="text-primary-100 text-sm">/ month</span>
                      </>
                    )}
                  </div>
                  {billingCycle === 'annual' && (
                    <p className="text-primary-100 text-xs mt-1">Billed as £47.99/year</p>
                  )}
                </div>
                <Link
                  to="/signup"
                  className="block w-full text-center bg-white text-primary-700 font-medium px-6 py-2.5 rounded-lg hover:bg-cream-100 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white mb-8"
                >
                  Start free
                </Link>
                <ul className="space-y-3">
                  {[
                    'Everything in Free',
                    'Unlimited people in care',
                    'Unlimited family members',
                    'Custody & handover tracking',
                    'Full activity history',
                  ].map((feature) => (
                    <li key={feature} className="flex items-start gap-3">
                      <svg className="h-5 w-5 flex-shrink-0 text-primary-100 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" strokeWidth={1.5} />
                        <path d="M8 12l3 3 5-5" />
                      </svg>
                      <span className="text-sm text-white">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="text-center mt-6 space-y-2">
              <p className="text-sm text-gray-500">No credit card required.</p>
              <Link to="/pricing" className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors">
                Full comparison &rarr;
              </Link>
            </div>
          </div>
        </section>

        {/* --------------------------------------------------------------- */}
        {/* CTA                                                             */}
        {/* --------------------------------------------------------------- */}
        <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-primary-600 to-primary-700">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Ready to coordinate your family's care?
            </h2>
            <p className="mt-4 text-lg text-primary-100">
              Join families who have found calm in the chaos.
            </p>
            <Link
              to="/signup"
              className="inline-block mt-8 bg-white text-primary-700 font-medium px-8 py-3 rounded-lg hover:bg-cream-100 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
            >
              Get Started Free
            </Link>
          </div>
        </section>
      </main>

      {/* ----------------------------------------------------------------- */}
      {/* Footer                                                            */}
      {/* ----------------------------------------------------------------- */}
      <footer className="bg-gray-900 text-gray-400">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <span className="font-fraunces text-xl font-light tracking-tight text-white">
                <em className="font-medium text-primary-300" style={{ fontStyle: 'italic' }}>Kin</em>Care
              </span>
              <p className="mt-2 text-sm">Care together.</p>
              <p className="mt-4 text-xs text-gray-500">
                &copy; {new Date().getFullYear()} KinCare. All rights reserved.
              </p>
            </div>

            {/* Product */}
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Product</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="#features" className="hover:text-white transition-colors">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#how-it-works" className="hover:text-white transition-colors">
                    How It Works
                  </a>
                </li>
                <li>
                  <Link to="/pricing" className="hover:text-white transition-colors">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/roadmap" className="hover:text-white transition-colors">
                    Roadmap
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors">
                    Sign In
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/privacy" className="hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/cookies" className="hover:text-white transition-colors">
                    Cookie Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="hover:text-white transition-colors">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>

            {/* Connect */}
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Connect</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="mailto:hello@kin.care" className="hover:text-white transition-colors">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
